import { Item } from '../services/api';

/** Full product title (without size suffix), for tooltips when name is truncated in DB. */
export function getFullProductTitle(item: Pick<Item, 'name' | 'description'>): string {
    const description = (item.description || '').trim();
    if (description) {
        const title = description.split(/\s*-\s*(?=\d)/)[0].trim().replace(/[ -]+$/, '');
        if (title) {
            return title;
        }
    }

    return item.name.replace(/\.\.\.$/, '').trim();
}
